import { FC, Fragment } from 'react';

import { List } from '@core/ui';
import { useDate, useTranslation } from '@wearehelpful/ui-localization';
import { ADTO } from '@helpful/network';
import { Icon, Badge, Typography } from '@wearehelpful/ui-kit';

import { Notes } from './VisitSummary.style';
import { replaceWithLinks } from './VisitSummary.utils';

export const VisitSummary: FC<ADTO.EncounterEntity> = (props) => {
  const { t } = useTranslation();
  const { format } = useDate();
  const { provider, connection, location, careplan } = props;

  return (
    <Fragment>
      {connection && <Badge variant="primary">{connection.system.name}</Badge>}

      {props.date && (
        <List.Item lines="none">
          <List.Thumb size="sm">
            <Icon name="calendar" size="sm" />
          </List.Thumb>
          <List.Label>{format({ value: props.date, format: 'LL' })}</List.Label>
        </List.Item>
      )}

      {props.date && (
        <List.Item lines="none">
          <List.Thumb size="sm">
            <Icon name="time" size="sm" />
          </List.Thumb>
          <List.Label>{format({ value: props.date, format: 'LT' })}</List.Label>
        </List.Item>
      )}

      {location && (
        <List.Item lines="none">
          <List.Thumb size="sm">
            <Icon name="location" size="sm" />
          </List.Thumb>
          <List.Label wrap>{location}</List.Label>
        </List.Item>
      )}

      {provider && (
        <List.Item lines="none">
          <List.Thumb size="sm">
            <Icon name="provider" size="sm" />
          </List.Thumb>
          <List.Label>
            {[
              provider?.prefix,
              provider?.firstName,
              provider?.lastName,
              provider?.suffix,
            ].join(' ')}
          </List.Label>
        </List.Item>
      )}

      {careplan?.description && (
        <Notes>
          <Typography variant="sub1" bold>
            {t('subheadings.visitSummaryDetails.title')}
          </Typography>
          {careplan?.description.split('\r\n').map((desc: any, i: any) => {
            return (
              <Fragment key={i}>
                <Typography variant="p1" key={i}>
                  {replaceWithLinks(desc)}
                </Typography>
                <br />
              </Fragment>
            );
          })}
        </Notes>
      )}
    </Fragment>
  );
};
